// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_mw-0";
export var buttonContainer = "_mw-3";
export var cancelButton = "_mw-4";
export var headerSection = "_mw-6";
export var headerTitle = "_mw-9";
export var messageSideLeft = "_mw-1";
export var messageSideRight = "_mw-2";
export var orderNumberContainer = "_mw-7";
export var orderNumberLabel = "_mw-8";
export var submitButton = "_mw-5";